import CHECKOUT_STEPS_ROUTES from '../routes/checkout';

const PLACE_ORDER_FALLBACK_ROUTE_STORAGE_KEY = 'placeOrderFallbackRoute';

export const setPlaceOrderFallbackRoute = (route: string = ''): void => {
  if (typeof window === 'undefined') return;

  window.sessionStorage.setItem(PLACE_ORDER_FALLBACK_ROUTE_STORAGE_KEY, route);
};

export const getPlaceOrderFallbackRoute = (): string => {
  if (typeof window === 'undefined') return CHECKOUT_STEPS_ROUTES.payment.path;

  return (
    window.sessionStorage.getItem(PLACE_ORDER_FALLBACK_ROUTE_STORAGE_KEY) ||
    CHECKOUT_STEPS_ROUTES.payment.path
  );
};
